import { render, staticRenderFns } from "./RightsIndicator.vue?vue&type=template&id=d0ef6e42&scoped=true"
import script from "./RightsIndicator.vue?vue&type=script&lang=js"
export * from "./RightsIndicator.vue?vue&type=script&lang=js"
import style0 from "./RightsIndicator.vue?vue&type=style&index=0&id=d0ef6e42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ef6e42",
  null
  
)

export default component.exports